// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"611830e1","150":"12e494a5","192":"278a08a4","312":"abc89b91","370":"8a2bc5f4","502":"dec4c112","707":"a04ea08d","811":"d3e834eb","828":"441d1bad"}[chunkId] + ".chunk.css";
};